import { render, staticRenderFns } from "./AttachedFiles.vue?vue&type=template&id=282348f0&scoped=true&"
import script from "./AttachedFiles.vue?vue&type=script&lang=js&"
export * from "./AttachedFiles.vue?vue&type=script&lang=js&"
import style0 from "./AttachedFiles.vue?vue&type=style&index=0&id=282348f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282348f0",
  null
  
)

export default component.exports